export enum ERecordState {
  INSERTED = 'Inserted',
  INSERTED_DURING_VERIFICATION = 'InsertedDuringVerification',
  VERIFIED = 'Verified',
  CONFIRMED = 'Confirmed',
  NOT_DONE = 'NotDone',
}
